import React from 'react';
import styled from 'styled-components';

import MetaTags from 'components/meta-tags';
import LoginForm from 'components/forms/login-form';
import type { IrlEvent } from 'src/gql/graphql';
import { Card, CardFooter } from './card';
import { FormWrapper, FooterText, FooterLink, Content } from './styles';
import { IrlEventEmailContentHeader } from './irl-event-email-signup';
import { IrlEventLogo } from './irl-event-logo';
import { useIrlEventParams } from '../hooks/use-irl-event-params';

type IrlEventEmailLoginProps = {
  irlEvent: IrlEvent;
  onLoginSuccess?: () => void;
  onBack?: () => void;
  onForgotPassword?: () => void;
};

export function IrlEventEmailLogin({
  irlEvent,
  onLoginSuccess,
  onBack,
  onForgotPassword,
}: IrlEventEmailLoginProps): JSX.Element {
  const { publicContextSessionId } = useIrlEventParams();

  const footer = (
    <CardFooter>
      <FooterText>
        <StyleFooterLink onClick={onForgotPassword} data-testid='irl-event-login-forgot-password-link'>
          Forgot your password?
        </StyleFooterLink>
      </FooterText>
    </CardFooter>
  );

  return (
    <>
      <MetaTags title='Log In' description='Log in to your account' />

      <Card footer={footer} data-testid='irl-event-email-login'>
        <IrlEventLogo headerImageUrl={irlEvent.headerImageUrl ?? null} />

        <IrlEventEmailContentHeader />

        <Content>
          <StyledFormWrapper>
            <LoginForm
              analyticsEventLabel='irl-event-login'
              onLoginSuccess={onLoginSuccess}
              onBack={onBack}
              publicContextSessionId={publicContextSessionId}
            />
          </StyledFormWrapper>
        </Content>
      </Card>
    </>
  );
}

// Hide the form's internal "Forgot your password?" link
const StyledFormWrapper = styled(FormWrapper)`
  .login-form-forgot-password-link {
    display: none;
  }
`;

const StyleFooterLink = styled(FooterLink)`
  color: var(--dcm-color-text-primary, ${({ theme }) => theme.colors.primaryBlack});
`;
